import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Card } from '@comparethemarketau/manor-card';

import { List } from 'immutable';

import { withUnavailableBrands } from './common/with_unavailable_brands';
import { BrandNoReturnedTitle } from './common/brand_no_returned_title';
import { BrandNoReturnedReason } from './common/brand_no_returned_reason';

import { ProviderLogo } from '../products/common/provider_logo';
import { ContainerWrapper } from '../container_wrapper';

const useStyles = createUseStyles((theme) => ({
    card: {
        display: 'flex',
        minHeight: '13rem',
        border: 'unset',
        margin: {
            bottom: theme.spacing[24]
        },
        padding: [theme.spacing[24], theme.spacing[28]],
        alignItems: 'center'
    },
    logo: {
        marginRight: theme.spacing[16]
    },
    textContainer: {
        height: '8.2rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around'
    },
    font: {
        fontSize: theme.fontSize.sm
    }
}));

const _UnavailableBrandsMd = (props) => {
    const { unavailableBrands, padding, availableQuotesSize } = props;
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        availableQuotesSize > 0 && (
            <ContainerWrapper padding={padding} className={classNames('test-unavailableBrands-md')}>
                {unavailableBrands
            && (
                unavailableBrands.map((quote, index) => {
                    const providerName = quote.get('providerMeta').get('name');
                    const providerCode = quote.get('providerMeta').get('code');
                    return (
                        <div key={`provider-${providerCode}`} id={`unavailable-brand-row-${index}`} data-provider-id={providerCode}>
                            <Card className={classes.card} boxShadow={false}>
                                <ProviderLogo className={classes.logo} code={providerCode} />
                                <div className={classes.textContainer}>
                                    <BrandNoReturnedTitle providerName={providerName} className={classes.font} />
                                    <BrandNoReturnedReason className={classes.font} />
                                </div>
                            </Card>
                        </div>

                    );
                })
            )}
            </ContainerWrapper>
        )
    );
};

_UnavailableBrandsMd.propTypes = {
    unavailableBrands: PropTypes.instanceOf(List),
    availableQuotesSize: PropTypes.number,
    padding: PropTypes.array
};

const UnavailableBrandsMd = withUnavailableBrands(_UnavailableBrandsMd);
export { UnavailableBrandsMd };
